/**
 * @module User
 */

import { Component, Input } from '@angular/core';
import { UserIdClass } from '@class/user.class';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-firstname',
  templateUrl: './firstname.component.html',
  styleUrls: ['./firstname.component.css']
})
export class FirstnameComponent {

  @Input() userId: UserIdClass;
  @Input() color: string = ItemColor('users');

  constructor() {}

  onFirstname(firstname: string) {
    this.userId.change({ firstname: firstname });
  }

}
